import { createFeatureSelector, createSelector } from "@ngrx/store";
import { AppState, PRODUCT_FEATURE } from "../../../app.state";
import { getMergedRoute } from "@app/marketplace/route/router-state.selectors";

export const productFeature = createFeatureSelector<AppState>(PRODUCT_FEATURE.stateKey);
export const selectLoading = createSelector(
  productFeature,
  (state: AppState) =>{
    return state.products_list.isLoading
 }
);
export const selectPayload = createSelector(
  productFeature,
  (state: AppState) => state.products_list.payload
);
export const selectResponse = createSelector(
  productFeature,
  (state: AppState) => state.products_list.data
);
export const selectConfiguration = createSelector(
  productFeature,
  (state: AppState) => state.products_list.data.configuration
);
export const selectItems = createSelector(
  productFeature,
  (state: AppState) => state.products_list.data.data
);
export const selectPageSize = createSelector(
  productFeature,
  (state: AppState) => state.products_list.data.pageSize
);
export const selectPageNo = createSelector(
  productFeature,
  (state: AppState) => state.products_list.data.pageIndex
);
export const selectCount = createSelector(
  productFeature,
  (state: AppState) => state.products_list.data.count
);
export const selectTotalData = createSelector(
  productFeature,
  (state: AppState) => state.products_list.data.totalCount
);
export const selectTotalPage = createSelector(
  productFeature,
  (state: AppState) => state.products_list.data.totalPages
);
export const selectedCategory= createSelector(getMergedRoute,(mergedRoute) => {
   return mergedRoute.params.id
});
